export default __webpack_public_path__ + "static/media/Comp 2_00023.e922b85b.png";